// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.line {\n    height: 7px;\n    margin: 0;\n    border-radius: 7px;\n    background: var(--shimmer-bg) !important;\n    animation: none !important\n    /* background-size: 300px; */\n    /*animation: shine-lines 1.6s infinite linear;*/\n}\n", ""]);
// Exports
module.exports = exports;
